import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useSettingsSectionHighlights(
  sectionKeys: string[],
): Record<string, boolean> {
  const [searchParams, setSearchParams] = useSearchParams();
  const highlightSection = searchParams.get('highlight');

  const matchedKey =
    highlightSection !== null && sectionKeys.includes(highlightSection)
      ? highlightSection
      : null;

  const [activeKey, setActiveKey] = useState<string | null>(matchedKey);

  useEffect(() => {
    if (!matchedKey) {
      setActiveKey(null);
      return;
    }
    setActiveKey(matchedKey);
    const timer = setTimeout(() => {
      setActiveKey(null);
      const next = new URLSearchParams(searchParams);
      next.delete('highlight');
      setSearchParams(next, { replace: true });
    }, 2500);
    return () => clearTimeout(timer);
  }, [matchedKey, searchParams, setSearchParams]);

  return Object.fromEntries(sectionKeys.map((key) => [key, activeKey === key]));
}
